import FormControlLabel, { type FormControlLabelProps } from '@mui/material/FormControlLabel';
import RadioBase, { type RadioProps as RadioBaseProps } from '@mui/material/Radio';
import { forwardRef } from 'react';

type RadioProps = Omit<FormControlLabelProps, 'control' | 'label'> & {
  label?: FormControlLabelProps['label'];
  radioProps?: RadioBaseProps;
};

const Radio = forwardRef(({ radioProps, label, ...props }: RadioProps, ref) => {
  return (
    <FormControlLabel {...props} control={<RadioBase {...radioProps} />} ref={ref} label={label} />
  );
});

Radio.displayName = 'Radio';

export type { RadioProps, RadioBaseProps };
export { Radio, RadioBase };
